import { UseFormProps } from 'react-hook-form';
import * as Form from 'components/form';
import * as Select from 'components/select';
import { ContactType } from 'constants/contacts';
import { PledgeCoveredFee, PledgeCoveredFeePolicy } from 'constants/fees';
import { InstallmentFrequency, PledgeStatus, PledgeType } from 'constants/pledges';
import { DateTime } from 'luxon';
import { Contact, ContactEmail, ContactPhone } from 'types/domain';

enum InstallmentStatus {
    Paid = 'paid',
    Active = 'active',
    Upcoming = 'upcoming',
    Late = 'late',
}

interface InstallmentFormItem {
    date: DateTime;
    amount?: number | string;
    status?: InstallmentStatus;
    override?: boolean;
}

interface PledgeFormValue {
    selectedContact: Select.SelectItemWithLabel<Contact>[];
    campaign: Select.SelectItemWithLabel<string>[] | null;
    fund: Select.SelectItemWithLabel<string>[] | null;
    status_friendly: PledgeStatus;
    amount: number;
    fulfilled_at: DateTime;
    installment_frequency: InstallmentFrequency;
    first_installment_date: DateTime;
    number_of_installments: number;
    installments: InstallmentFormItem[];
    type: PledgeType;
    auto_remind: boolean;
    memo: string;
    internal_note: string;
    fee_coverage_type: PledgeCoveredFee;
    fee_coverage_visibility: PledgeCoveredFeePolicy;
    include_in_campaign_goal: boolean;
    firstName: string;
    lastName: string;
    contactType: ContactType;
    emails: ContactEmail[];
    phones: ContactPhone[];
    allow_custom_amount: boolean;
    companyName: string;
    notify_immediately: boolean;
}

const usePledgeForm = ({ defaultValues, ...formProps }: UseFormProps<PledgeFormValue> = {}) => {
    return Form.useGivebutterForm<PledgeFormValue>({
        defaultValues: {
            installment_frequency: InstallmentFrequency.OneTime,
            fulfilled_at: DateTime.now(),
            first_installment_date: DateTime.now(),
            installments: [],
            fee_coverage_type: PledgeCoveredFee.All,
            include_in_campaign_goal: false,
            allow_custom_amount: true,
            auto_remind: false,
            fee_coverage_visibility: PledgeCoveredFeePolicy.AskToCoverFees,
            type: PledgeType.Donation,
            firstName: '',
            lastName: '',
            emails: [{ value: '', is_primary: true, type: 'personal' }],
            phones: [{ value: '', is_primary: true, type: 'home' }],
            campaign: null,
            fund: null,
            memo: '',
            internal_note: '',
            contactType: ContactType.Individual,
            notify_immediately: false,
            ...defaultValues,
        },
        ...formProps,
    });
};

export { usePledgeForm, InstallmentStatus };
export type { PledgeFormValue, InstallmentFormItem };
